export default (title, subtitle, seriesData = [], categories = []) => {
	const hasCategories = categories.length > 0
	const isSingleSeries = !hasCategories && seriesData.every((s) => s.values && s.values.length === 1)

	let scaleXValues, series
	if (isSingleSeries) {
		scaleXValues = seriesData.map((s) => s.text || '')
		series = [
			{
				values: seriesData.map((s) => s.values[0]),
				styles: seriesData.map((s) => s.backgroundColor || undefined)
			}
		]
	} else {
		scaleXValues = categories
		series = seriesData.map((serie, idx) => ({
			values: serie.values,
			text: serie.text || `Series ${idx + 1}`,
			backgroundColor: serie.backgroundColor || undefined
		}))
	}

	return {
		type: 'bar',
		title: { text: title, fontSize: 18 },
		subtitle: { text: subtitle },
		scaleX: {
			values: scaleXValues,
			item: {
				angle: -45,
				wrapText: true,
				fontSize: 10,
				maxChars: 20
			}
		},
		scaleY: { label: { text: 'Count' } },
		series: series,
		plot: {
			barWidth: '50%',
			tooltip: { text: '%kt: %v' }
		},
		plotarea: {
			marginBottom: 120,
			marginLeft: 60
		}
	}
}
